// * react imports
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// * styles imports
import GlobalStyle from "./globalStyles";
import GlobalFonts from "./fonts/fonts";

//  * components imports
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar/Navbar";
import AboveFooter from "./components/AboveFooter/AboveFooter";
import Footer from "./components/Footer/Footer";

// * pages import
import Home from "./Pages/Homepage/Home";
import Story from "./Pages/Storypage/Story";
import Fantasy from "./Pages/Fantasypage/Fantasy";
import History from "./Pages/Historypage/History";
import Horror from "./Pages/Horrorpage/Horror";
import Crime from "./Pages/Crimepage/Crime";
import { Form } from "./Pages/Registeration/Form/Form";

function App() {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <GlobalFonts />
      <Navbar />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/Stories" exact component={Story} />
        <Route path="/Fantasies" exact component={Fantasy} />
        <Route path="/Histories" exact component={History} />
        <Route path="/Horrors" exact component={Horror} />
        <Route path="/Crimes" exact component={Crime} />
        <Route path="/Registeration" exact component={Form} />
      </Switch>
      <AboveFooter />
      <Footer />
    </Router>
  );
}

export default App;
